/* Mobil çekmece: "Tüm Kategoriler" başlığı -> /collections linki + ok ikonu (masaüstü ile aynı) */
(function () {
  'use strict';
  function run() {
    var I18N = window.FAV_MOBILE_I18N || {};
    var label = I18N.all_categories || 'Tüm Kategoriler';
    var root = String(I18N.root || '/').replace(/\/+$/, '');
    var href = (root + '/collections').replace(/\/{2,}/g, '/');
    var titles = document.querySelectorAll('#fav-drawer .fav-drawer-sec-title');
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      if (t.querySelector('.fav-allcats-link') || (t.textContent || '').trim() !== label) continue;
      var a = document.createElement('a');
      a.className = 'fav-allcats-link';
      a.href = href;
      a.title = label;
      a.setAttribute('aria-label', label);
      a.innerHTML = '<span class="fav-allcats-txt"></span><span class="fav-allcats-ic" aria-hidden="true"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg></span>';
      a.firstChild.textContent = label;
      t.textContent = '';
      t.appendChild(a);
    }
    if (!document.getElementById('fav-allcats-m-css')) {
      var s = document.createElement('style');
      s.id = 'fav-allcats-m-css';
      s.textContent = '#fav-drawer .fav-allcats-link{display:inline-flex;align-items:center;gap:8px;color:inherit;text-decoration:none;font:inherit;letter-spacing:inherit;text-transform:inherit}' +
        '#fav-drawer .fav-allcats-ic{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:50%;border:1.5px solid currentColor;background:var(--fav-cyan-3,#e6f7fb);color:var(--fav-cyan,#0aa5c8);flex:none}' +
        '#fav-drawer .fav-allcats-link:active .fav-allcats-ic{background:var(--fav-cyan,#0aa5c8);color:#fff}';
      document.head.appendChild(s);
    }
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
